import { render } from "./StemSection.vue?vue&type=template&id=48700fa5&scoped=true"
import script from "./StemSection.vue?vue&type=script&lang=js"
export * from "./StemSection.vue?vue&type=script&lang=js"

import "./StemSection.vue?vue&type=style&index=0&id=48700fa5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48700fa5"]])

export default __exports__